import { Box, Button, Divider, Heading, Tag, Text } from '@flixbus/honeycomb-react';
import { useNavigate } from 'react-router-dom';
import {
  Icon,
  IconArrowLeft,
  IconCheckmarkStrongSolid,
  IconOffer,
  IconVoucher,
} from '@flixbus/honeycomb-icons-react';
import { Link } from 'react-router-dom';
import { DateTime } from 'luxon';

import { CopyVoucher } from '../CopyVoucher';

import DiscountTypeFields from '../VoucherInfo/Info/DiscountTypeFields';
import { useVoucher } from '../../context/VoucherProdiver';

import styles from './creation-success.module.scss';

const CreationSuccess = () => {
  const { data } = useVoucher();
  const navigate = useNavigate();

  return (
    <div className={styles.container}>
      <Button extraClasses={styles.back} Elem='a' RouterLink={Link} to='/'>
        <Icon InlineIcon={IconArrowLeft} />
        Back to home
      </Button>
      <div className={styles.icon}>
        <flix-illustration name='voucher'></flix-illustration>
      </div>
      <Heading flushSpace extraClasses={styles.title} size={1}>
        Voucher Created!{' '}
        <Icon extraClasses={styles.checkmark} InlineIcon={IconCheckmarkStrongSolid} size={5} />
      </Heading>
      <Box appearance='success' extraClasses={styles.box}>
        <Text extraClasses={styles.boxTitle}>
          <Icon size={6} extraClasses={styles.boxIcon} InlineIcon={IconVoucher} />
          Voucher summary
        </Text>
        <Divider extraClasses={styles.divider} />
        <div>
          <Text small>
            Prefix: <strong>{data.prefix}</strong>
          </Text>
          <Text extraClasses={styles.createdBy} small>
            Created by: <Tag Elem='span'>{data.createdBy || 'John Doe'}</Tag>
          </Text>
        </div>
        <Divider extraClasses={styles.divider} />
        <div className={styles.copy}>
          <div>
            <Text>
              Voucher code: <strong>{data.code}</strong>
            </Text>
            {DiscountTypeFields(data.discountType).map(f => (
              <Text key={f.label}>
                {f.label}: <strong>{f.value}</strong>
              </Text>
            ))}
            <Text>
              Valid from:{' '}
              <strong>
                {DateTime.fromISO(data.validityInterval.validSince)
                  .setLocale('de')
                  .toLocaleString()}
              </strong>
            </Text>
            <Text>
              Valid until:{' '}
              <strong>
                {DateTime.fromISO(data.validityInterval.validUntil)
                  .setLocale('de')
                  .toLocaleString()}
              </strong>
            </Text>
          </div>
          <CopyVoucher />
        </div>
      </Box>
      <div>
        <Button appearance='primary' Elem='a' onClick={() => navigate(-1)}>
          <Icon InlineIcon={IconOffer} />
          Create new voucher
        </Button>
      </div>
    </div>
  );
};

export default CreationSuccess;
